<template>
  <div class="layout-page">
    <el-container>
      <el-main>
        <el-header height="44px">
          <div class="header-content">
            <div class="left-box">
              <template v-if="hasLogin">
                <el-dropdown>
                  <div class="name">{{ userInfo.nickname }}</div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-for="menu in myCenterMenuList" :key="menu.code">
                      <div @click="goFunc(menu);">{{ menu.name }}</div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
				 <div class="loginout group-name" v-if="userInfo.enterpriseType == 'SALESMAN'" @click="dialogVisible = true;">{{userInfo.groupName}} <i class="iconfont icon-jiantouxia"></i> </div>
                <div class="loginout" @click="logout();">退出登录</div>
              </template>
              <div class="login" @click="goLogin();" v-else>请登录</div>
            </div>
            <div class="right-box">
              <div class="func" v-if="hasLogin" @click="toPath('download')">企业资质下载</div>
              <div class="func" @click="toPath('license')">公司经营资质</div>
              <div class="func" @click="goCustomer();">联系客服</div>
              <div class="func">
                <el-dropdown>
                  <div class="code-box">
                    <div class="icon-box">
                      <i class="iconfont icon-xiaochengxu"></i>
                    </div>
                    <div class="name">漱玉优乐采小程序</div>
                  </div>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      <img src="../assets/images/wxcode.jpg" width="120" height="120"></img>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </div>
        </el-header>

        <div class="main-content">
          <transition name="fade-transform" mode="out-in">
            <router-view :key="key"/>
          </transition>
        </div>
        <vFooter></vFooter>
      </el-main>
    </el-container>
	<el-dialog
	  title=""
	  :visible.sync="dialogVisible"
	  width="683px"
	  :show-close="false"
	  custom-class="group-dialog">
	  <group-list pageType="change" @handleClose="dialogVisible = false"></group-list>
	  </span>
	</el-dialog>
  </div>
</template>

<script>
import {getMaterialFiles} from '@/api/home'
import vFooter from './vFooter.vue';
import groupList from '@/components/groupList.vue';
import {
  mapGetters
} from 'vuex';

export default {
  name: "layout",
  components: {
    vFooter,
	groupList
  },
  data() {
    return {
		dialogVisible:false,
		myCenterMenuList: []
	};
  },
  computed: {
    ...mapGetters(['hasLogin', 'userInfo']),

    key() {
      if (!this.$route.meta || (this.$route.meta && this.$route.meta.parent !== 'home' && this.$route.meta.parent !== 'mycenter')) {
        return this.$route.path;
      }
    }
  },
  created() {
  	// 业务员不展示账户
  	if (this.userInfo.enterpriseType == 'SALESMAN') {
  		this.myCenterMenuList = this.mixin_myCenterMenuList.filter(item => item.code != 'wdzh');
  	}
  	else {
  		this.myCenterMenuList = this.mixin_myCenterMenuList;
  	}
  },
  methods: {
    toPath(type) {
      let url = process.env.VUE_APP_WEB_LOCATION;
      if (type === 'license') {
        window.open(url + '/#/license?key=license')
      }

      if (type === 'download') {
        getMaterialFiles().then(response => {
          if (response?.code === "0") {
			  if(response?.data?.records.length > 0){
				  window.open(response.data.records[0].url)
			  } else {
				  this.$message.warning("未查询到企业资料")
			  }
          } else {
            this.$message.error("下载失败")
          }
        })
      }
    },

    goLogin() {
      this.$router.push('/login');
    },

    goCustomer() {
      this.$store.commit('SET_MYCENTERSELECTEDMENU', 'kffw');
      this.$router.push('/service');
    },

    logout() {
      this.$confirm('是否确认退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.$store.dispatch("logout").then(result => {
          this.$message('成功退出登录');
          this.$router.push('/home');
        });
      });
    },

    goFunc(item) {
      if (item.path) {
        this.$store.commit('SET_MYCENTERSELECTEDMENU', item.code);
        this.$router.push(item.path);
      }
    }
  },
};
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.layout-page {
  margin: 0 auto;
  width: calc(100vw - 4px);
  height: calc(100vh - 4px);
  min-width: 1240px;
  box-sizing: border-box;

  .el-header {
    width: 100%;
    background-color: #EDEFF2;
    padding: 0;

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      padding: 0 20px;
      width: 1240px;
      min-width: 1240px;
      height: 44px;
      font-size: 13px;
      color: #262728;

      .left-box {
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .title {
          margin-right: 40px;
        }

        .login,
        .name {
          position: relative;
          padding-right: 8px;
          cursor: pointer;
        }

        .name::before {
          content: '';
          position: absolute;
          top: 50%;
          right: 0;
          transform: translateY(-50%);
          width: 2px;
          height: 12px;
          background: #C0C4CC;
          border-radius: 1px;
        }

        .login:hover,
        .name:hover {
          text-decoration: underline;
        }
		.group-name {
			position: relative;
			padding-right: 8px;
			.iconfont {
				font-size: 10px
			}
		}
		.group-name::before {
		  content: '';
		  position: absolute;
		  top: 50%;
		  right: 0;
		  transform: translateY(-50%);
		  width: 2px;
		  height: 12px;
		  background: #C0C4CC;
		  border-radius: 1px;
		}

        .loginout {
          margin-left: 8px;
          cursor: pointer;
        }

        .loginout:hover {
          text-decoration: underline;
        }
      }

      .right-box {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .func {
          margin-left: 60px;
          cursor: pointer;

          .code-box {
            display: flex;
            justify-content: flex-end;
            align-items: center;

            .icon-box {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 22px;
              height: 22px;
              border: 1px solid #909399;
              border-radius: 50%;

              .iconfont {
                font-size: 10px;
                color: #262728;
              }
            }

            .name {
              margin-left: 6px;
              font-size: 13px;
              color: #262728;
            }
          }
        }

        .func:hover {
          text-decoration: underline;
        }
      }
    }
  }

  .el-main {
    padding: 0;
    background-color: #F8F8F8;

    .main-content {
      margin: 0 auto;
      box-sizing: border-box;
      min-height: calc(100vh - 334px);
      overflow: hidden;
    }
  }
  .group-dialog {
	  border-radius: 16px;
	  .el-dialog__header {
		  display: none;
	  }
	  .el-dialog__body {
		  padding: 0;
		  
	  }
  }
}
</style>
